import { useCallback } from 'react'
import { useSearchParams } from 'react-router-dom'

export function useQualityNumberFilters() {
  const [searchParams, setSearchParams] = useSearchParams()

  const wabaId = searchParams.get('wabaId')?.split(',') ?? undefined
  const search = searchParams.get('search') ?? undefined
  const status = searchParams.get('status')?.split(',') ?? undefined
  const quality = searchParams.get('quality')?.split(',') ?? undefined
  const page = searchParams.get('page') ?? 1
  const pageSize = searchParams.get('pageSize') ?? 10

  const setInputSearch = useCallback(
    (value) => {
      setSearchParams((params) => {
        if (value) params.set('search', value)
        else params.delete('search')
        return params
      })
    },
    [setSearchParams],
  )

  const setFilters = useCallback(
    (filters) => {
      setSearchParams((params) => {
        if (filters.wabaId?.length) params.set('wabaId', filters.wabaId)
        else params.delete('wabaId')

        if (filters.status?.length) params.set('status', filters.status)
        else params.delete('status')

        if (filters.quality?.length) params.set('quality', filters.quality)
        else params.delete('quality')

        return params
      })
    },
    [setSearchParams],
  )

  const setPage = useCallback(
    (pageParams) => {
      setSearchParams((params) => {
        params.set('page', pageParams.page)
        params.set('pageSize', pageParams.pageSize)

        return params
      })
    },
    [setSearchParams],
  )

  const unsetInputSearch = useCallback(() => {
    setSearchParams((params) => {
      if (search) params.delete('search')

      return params
    })
  }, [search, setSearchParams])

  const unsetFilters = useCallback(() => {
    setSearchParams((params) => {
      if (wabaId) params.delete('wabaId')
      if (status) params.delete('status')
      if (quality) params.delete('quality')

      return params
    })
  }, [quality, setSearchParams, status, wabaId])

  return {
    filters: {
      wabaId,
      search,
      status,
      quality,
      page,
      pageSize,
    },
    setFilters,
    setInputSearch,
    setPage,
    unsetFilters,
    unsetInputSearch,
  }
}
